<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class="h-outTabs">
        <ejs-tab ref="tabObj" heightAdjustMode="None" :selected='selectTab'>
          <e-tabitems>
            <e-tabitem :header='tab.alarmSocketText' content='#account_tab1' cssClass='h-tab-noClose'></e-tabitem>
            <e-tabitem :header='tab.alarmOperText' content='#account_tab2' cssClass='h-tab-noClose'></e-tabitem>
            <e-tabitem :header='tab.currentAlarmSummaryText' content='#account_tab3' cssClass='h-tab-noClose'></e-tabitem>
          </e-tabitems>
          <!-- <div class="e-tab-header">
            <div content='#account_tab1' cssClass='h-tab-noClose'>{{$t('Alarm.alarmSocket')}}</div>
            <div content='#account_tab2' cssClass='h-tab-noClose'>{{$t('Alarm.alarmOper')}}</div>
            <div content='#account_tab3' cssClass='h-tab-noClose'>{{$t('Alarm.currentAlarmSummary')}}</div>
          </div> -->
        </ejs-tab>
          <!-- <div class="e-content"> -->
            <div id="account_tab1" class="h-alarm-100vh-0 ">
              <div class="h100-140 h-scroll">
                <CurrentAlarmSocket ref='alarmSocket' :roleNetMap='roleNetMap' :roleNe='roleNetList' @count='refreshCount' @updataCount='updataCount'></CurrentAlarmSocket>
              </div>
            </div>
            <div id="account_tab2" class="h-alarm-100vh-0 ">
              <AlarmTableButton ref='alarmTableButton' @notice='notice' @isOn='changeIsOn' @keywords='changeKeywords'
                :refreshBtn='true' :exportBtn='exportBtnBoolean' :syncBtn='syncBtnBoolean' :separatorLine='true' :confirmBtn='confirmBtnBoolean' :clearBtn='clearBtnBoolean' :printBtn='printBtnBoolean' :alarmSyncBtn='true'
                :showDetailBtn='showDetailBtnBoolean' :shieldBtn='shieldBtnBoolean' :filterBtn='filterBtnBoolean' :hiddenBtn='hiddenBtnBoolean' :subscritionBtn='false' :autoConfirmBtn='autoConfirmBtnBoolean' :keywordsInput='true' :updateBtn='updateBtnBoolean'></AlarmTableButton>
              <AlarmCount :roleNe='roleNetList' ref='alarmCount'></AlarmCount>
              <div class="h100vh-200 h-scroll">
                 <AlarmTable :roleNetMap='roleNetMap' @count='refreshCount' @updataCount='updataCount' :roleNe='roleNetList' ref='alarmTable'></AlarmTable>
              </div>
            </div>
            <div id="account_tab3" class="h-alarm-100vh-0 ">
              <!---<div class="h100vh-200 h-scroll">
                 <AlarmTable :roleNetMap='roleNetMap' @count='refreshCount' @updataCount='updataCount' :roleNe='roleNetList' ref='alarmTable'></AlarmTable>
              </div>-->

              <div id='staticsChar' class='h100vh-140 h-scroll'>
                <StaticsChar ref='staticsCharRef' :roleNe='roleNetList' url='/lte/ems/fm/alarmcurrent/getStatisticsInfo' ></StaticsChar>
              </div>
            </div>
          <!-- </div> -->
      </div>
<!--      <AlarmCount :roleNe='roleNetList' ref='alarmCount'></AlarmCount>-->
<!--      <div class="h100-140 h-scroll">-->
<!--        <CurrentAlarmSocket :roleNetMap='roleNetMap' :roleNe='roleNetList' @count='refreshCount' @updataCount='updataCount'></CurrentAlarmSocket>-->
<!--      </div>-->
      <div >
        <audio  ref="myaudio"  :src="playSrc" hidden="true"></audio>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import AlarmCount from '../../components/alarmconfig/currentAlarm/CurrentAlarmCount';
import AlarmTableButton from '../../components/alarmconfig/currentAlarm/CurrentAlarmTableButton';
import AlarmTable from '../../components/alarmconfig/currentAlarm/CurrentAlarmTable';
import CurrentAlarmSocket from '../../components/alarmconfig/currentAlarm/CurrentAlarmSocket';
import StaticsChar from '../../components/alarmconfig/currentAlarm/StatisticsChar';

export default {
  name: 'CurrentAlarmPage',
  components: {
    BasicLayout,
    AlarmCount,
    AlarmTableButton,
    AlarmTable,
    CurrentAlarmSocket,
    StaticsChar
  },
  data() {
    return {
      playSrc: localStorage.getItem('alarmsound'),
      // playSrc:"http://192.168.53.58/audios/bell.mp3",
      exportBtnBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_dealwith.Export,
      syncBtnBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_dealwith.Sync,
      confirmBtnBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_dealwith.Confirm,
      clearBtnBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_dealwith.Clear,
      showDetailBtnBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_dealwith.AlarmDetails,
      shieldBtnBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_dealwith.Shield,
      filterBtnBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_dealwith.Filter,
      hiddenBtnBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_dealwith.Hidden,
      autoConfirmBtnBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_dealwith.AutoAcknowledge,
      printBtnBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_dealwith.Print,
      updateBtnBoolean:JSON.parse(sessionStorage.getItem('authMap')).alarm_dealwith.alarmUpdate,
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.currentAlarm')}`
      },
      roleNetMap: {},
      roleNetList: [],
      tab: {
        alarmSocketText: { text: this.$t('Alarm.alarmSocket') },
        alarmOperText: { text: this.$t('Alarm.alarmOper') },
        currentAlarmSummaryText: { text: this.$t('Alarm.currentAlarmSummary') }
      },
    };
  },
  methods: {
    selectTab(event) {
      if (event.selectedIndex === 0) {
        this.$refs.alarmSocket.getAlarmListData();
      } else if (event.selectedIndex === 1) {
        this.$refs.alarmCount.getAlarmCount();
        this.$refs.alarmTable.getAlarmListData();
      }
    },
    changeIsOn(args) {
      this.$refs.alarmTable.isOn = args;
    },
    changeKeywords(args) {
      this.$refs.alarmTable.queryConditions.keywords = args;
    },
    refreshCount(args) {
      this.$refs.alarmCount.getAlarmCount(args);
      // 韩洪波 2023-06-26 增加告警过滤图标切换，判断有过滤条件触发
      console.log('refreshCount args:', args);
      let isfiltered = false;
      if (args) {
        if (args.conditions !== undefined && args.conditions !== null && args.conditions !== '') {
          // 不判断搜索关键字，关键字在过滤的外面。args.keywords;
          isfiltered = true;
        }
      }
      this.$refs.alarmTableButton.setFilered(isfiltered);
    },
    updataCount(args) {
      this.$refs.alarmCount.addCount(args);
    },
    notice(type) {
      switch (type) {
        case 'refresh':
          this.$refs.alarmTable.queryConditions.conditions = '';
          this.$refs.alarmTable.queryConditions.keywords = '';
          this.$refs.alarmTable.getAlarmListData();
          break;
        case 'conditions':
          this.$refs.alarmTable.conditionsStatus = true;
          this.$refs.alarmTable.getAlarmListData(true);
          break;
        case 'keywords':
          this.$refs.alarmTable.conditionsStatus = false;
          this.$refs.alarmTable.getAlarmListData(true);
          break;
        case 'export':
          this.$refs.alarmTable.exportAlarmListData();
          break;
        case 'exportAll':
          this.$refs.alarmTable.exportAllAlarmListData();
          break;
        case 'sync':
          this.$refs.alarmTable.syncFunc();
          break;
        case 'confirm':
          this.$refs.alarmTable.confirmAlarm();
          break;
        case 'clear':
          this.$refs.alarmTable.clearAlarm();
          break;
        case 'showDetail':
          this.$refs.alarmTable.showDetail();
          break;
        case 'shield':
          this.$refs.alarmTable.shieldAlarm();
          break;
        case 'filter':
          this.$refs.alarmTable.filterFunc();
          break;
        case 'hidden':
          this.$refs.alarmTable.hiddenFunc();
          break;
        case 'autoConfirm':
          this.$refs.alarmTable.autoConfirmFunc();
          break;
        case 'update':
          this.$refs.alarmTable.updateFunc();
          break;
        case 'alarmSync':
          this.$refs.alarmTable.alarmSyncFunc();
          break;
        default:
      }
    }
  },
  beforeMount() {
    const This = this;
    This.roleNetMap = {};
    This.roleNetList = [];
    This.$axios.get('/lte/ems/auth/findNodeIdByAuth').then((response) => {
      if (response && response.status === 200) {
        for (let i = 0; i < response.data.length; i++) {
          //nodeId为0代表网管内部告警，为了便于查询到数据，所以做了逻辑补充
          if (!response.data.includes(0)) {
            response.data.push(0);
          }
          This.roleNetMap[response.data[i]] = 1;
          This.roleNetList.push(response.data[i]);
        }
      }
    });
  },
  mounted(){
    this.playSrc = localStorage.getItem('alarmsound');
    console.log("playSrc",localStorage.getItem('alarmsound'));
  }
};
</script>
